import { Route } from "react-router-dom";
import { ProtectedRoute } from "../../routers/protected-route";
import { MailMessages } from "./pages";

export const MailMessagesRouter = [
  <Route
    path="/mail-messages"
    element={
      <ProtectedRoute roles={["Any"]}>
        <MailMessages />
      </ProtectedRoute>
    }
  />,
];
